/**
 * Configuración de la constante de BUSINESS_CONST
 *
 * *Constant BUSINESS_CONST configuration*
 */
export const BUSINESS_CONST = {
  PRODUCT_TYPE_TC: 'creditCard',
  PRODUCT_TYPE_PAYROLL: 'payroll',
  PRODUCT_FOR_INCOMES_NOM: 'NOMINA',
  PRODUCT_TYPE_SAVINGS: 'savings',
  PRODUCT_TYPE_REVOLVING: 'revolvingCredit',
  PRODUCT_TYPE_FREE: 'freeInvestment',
  PRODUCT_TYPE_LIVING: 'livingPlace',
  PRODUCT_TYPE_LOAN: 'loan',
  PRODUCT_TYPE_LIB: 'LBR',
  PRODUCT_REQUEST_CONSULT: 'ConsultationRequest',
  MASTER: 'Master',
  MASTERCARD: 'Mastercard',
  VISA: 'Visa',
  VISALM: 'Visa LifeMiles',
  MULTI: 'multi',
  CHEQUE: 'cheque',
  ITAU: 'itau',
  OTRO_BANCO: 'otro_banco',
  CHEQUE_OTRO_BANCO: 'cheque_otro_banco',
  CHEQUE_ITAU: 'cheque_itau',
  CH: 'CH',
  ACH: 'ACH',
  AC: 'AC',
  ACCOUNT: 'Cuenta de ahorros',
  AHO: 'AHO',
  CO: 'CTE',
  CREDIT_CARD: 'Tarjeta de crédito',
  FREE_INVESTMENT: 'Crédito personal',
  PRODUCT_CODE_TCR: 'TCR',
  PRODUCT_CODE_ORD: 'ORD',
  PRODUCT_CODE_CRP: 'CRP',
  PRODUCT_CODE_AHO: 'AHO',
  PRODUCT_CODE_NOM: 'NOM',
  PRODUCT_CODE_FREE: 'ORD',
  PRODUCT_CODE_LOA: 'LOA',
  AGREEMENT_OPERATION_FLAG_SI: 'SI',
  AGREEMENT_OPERATION_FLAG_NO: 'No',
};

export const BANK_INFO_CONST = {
  NAME: 'itau',
  BANK_ID: '00000014',
  CURRENCY: 'COP',
};
